import React from "react";
import { useSubscription } from "@apollo/client";
import { Box } from "grommet";
import { DataGrid } from "@mui/x-data-grid";
import { CLUBMATE_EVENTS_LIST } from "./UserEventListGQL.js";
import moment from "moment";

function UserClubMateEventList(props) {
    const { data, loading } = useSubscription(CLUBMATE_EVENTS_LIST);

    const transformData = (data) => {
        if (!data) return [];
        return data["clubmate_entrance_clubmatereservation"].map((event) => ({
            id: event.id,
            datetime: moment(event.datetime).format("DD-MM-YYYY HH:mm:ss"),
            serviceName: event.clubmateservice_clubmateservice.name,
            userName: `${event.usersregister_userregister.name} ${event.usersregister_userregister.surname} ${event.usersregister_userregister.fiscal_code}`
        }));
    };

    const rows = transformData(data);

    const columnsEvents = [
        { field: 'datetime', headerName: 'Data e Ora', width: 200 },
        { field: 'serviceName', headerName: 'Servizio', width: 250 },
        { field: 'userName', headerName: 'Utente', width: 300 },
    ];

    return (
        <Box overflow="auto" height="100%" width="100%" alignSelf='center' style={{marginTop:'40px'}} margin={"small"}>
            <div style={{ height: '80vh', width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columnsEvents}
                    loading={loading}
                />
            </div>
        </Box>
    );
}

export default UserClubMateEventList;
